<template>
    <div>
        <div class="top_texts">
            <h3>
                Voer uw aansluitingsnummer in om uw gegevens in te laden
            </h3>
            <p>
                Dit nummer kunt u vinden door in te loggen op Checkout en te navigeren naar: <br/>
                Instellingen -> Abonnement
            </p>
        </div>
        <div class="row_container">
            <div style="width: 50%;">
                <div class="form-group">
                    <label style="color: red;" v-if="invalid_number">Onjuist nummer</label>
                    <label for="connection_number">Mijn aansluitingsnummer is:</label>
                    <input id="connection_number" type="text" v-model="connection_number">
                </div>
            </div>
        </div>
        <div>
            <button class="btn btn-default pull-left" @click="$emit('prev_step')"
                    :class="{'is-disabled': working || loading}">
                Vorige stap
            </button>
            <button class="btn btn-primary pull-right" @click="get_data_with_confirm_number"
                    :class="{'is-disabled': working || loading}">
                Volgende stap
                <span v-if="working || loading">
                    <font-awesome-icon :icon="['fal', 'spinner']" spin></font-awesome-icon>
                </span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            contract: {},
            working: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                loading: false,
                connection_number: null,
                invalid_number: false,
            };
        },
        methods: {
            get_data_with_confirm_number() {
                const self = this;

                self.invalid_number = false;

                if (!self.connection_number) {
                    return;
                }

                self.loading = true;

                self.$rest(
                    '/checkout/signup/service/user/get_contract_confirmation/',
                    {
                        body: {
                            urlsafe: self.contract.urlsafe,
                            confirmation_code: self.connection_number,
                        },
                    },
                ).then((response) => {
                    self.loading = false;
                    if (response.success) {
                        self.$emit('set_contract', response.model || {});
                        self.$emit('set_confirmed', {
                            value: true,
                            connection_number: self.connection_number,
                        });
                        self.$emit('next_step');
                    } else {
                        self.invalid_number = true;
                    }
                });
            },
        },
    };
</script>
